import React, {Component} from 'react';
import "./DetailPage.css";
import {Link} from "react-router-dom";
import LoginPanel from "./LoginPanel";
import App from "./App";
import TicketPanel from "./TicketPanel";

export default class DetailPage extends Component
{
  constructor(props)
  {
    super(props);
    this.state = {};

  }

  componentWillMount()
  {
    LoginPanel.verifyLogin(this.loadData.bind(this));
  }
  componentDidMount()
  {
    window.scrollTo(0,0);
  }

  loadData()
  {
    let actId = this.props.match.params.id;
    actId = parseInt(actId);
    App.gw.gwActivityFind(actId,(data)=>{
        this.setState({data});
    });


  }

  render()
  {
    window.document.title = "文化进社区活动5月份课程";

    let actId = this.props.match.params.id;
    actId = parseInt(actId);
    if (actId == 1)
    {
      return (
        <div className="DetailPage">
          <div id="banner">
            <img src={require("./h5_banner2.png")} alt="" className="fullHorizontalImg"/>
          </div>


          <div className="content">
            <h1>画画课程</h1>
            <p className="priceTf">¥ 免费</p>
            <p className="fieldTf"><img src={require("./h5_icon_people_normal.png")} alt=""/>面向儿童</p>
            <p className="fieldTf"><img src={require("./h5_icon_bigtime_normal.png")} alt=""/>4月25日起 每周四16:00-17:00</p>
            <p className="fieldTf"><img src={require("./h5_icon_local_normal.png")} alt=""/>共和新路街道社区群团服务中心（平型关路471号）</p>

          </div>

          <div className="hr2" style={{marginTop: "20px"}}></div>
          <div className="content">
            <div className="author">
              <img src={require("./icon.png")} alt="" className="aijiaIcon"/>
              <p className="nameTf">爱家君</p>
              <div className="right">
                <a href="tel:18602039256" className="contactBtn">联系ta</a>
              </div>
            </div>
          </div>
          <div className="hr2"></div>


          <div className="content" style={{marginBottom: "30px",paddingBottom:"50px"}}>
            <h3>
              <div className="h3Icon"></div>
              教师简介
            </h3>

            <h4>
              王巧云老师
            </h4>

            <p>师从中央美术学院和清华大学老师，拥有十年以上绘画和
              教学经历，多次获得过绘画书法比赛一、二等奖，深受艺
              术熏陶。</p>
            <p>2年儿童绘画教学经验</p>
            <p>3年高中绘画教学经验</p>
            <p>性格乐观开朗，活泼快乐，深受孩子们喜欢！</p>


            <h3 style={{marginTop: "30px"}}>
              <div className="h3Icon"></div>
              精彩分享
            </h3>


            <img src={require("./h5_drawing_pic.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ 王巧芸老师</p>

          </div>

          { this.renderBtn()          }

        </div>
      );
    }else {
      return (
        <div className="DetailPage">
          <div id="banner">
            <img src={require("./h5_banner3.png")} alt="" className="fullHorizontalImg"/>
          </div>


          <div className="content">
            <h1>瑜伽课程</h1>
            <p className="priceTf">¥ 免费</p>
            <p className="fieldTf"><img src={require("./h5_icon_people_normal.png")} alt=""/>面向中青年</p>
            <p className="fieldTf"><img src={require("./h5_icon_bigtime_normal.png")} alt=""/>4月25日起 每周四16:00-17:00 每周六10:00-11:00</p>
            <p className="fieldTf"><img src={require("./h5_icon_local_normal.png")} alt=""/>共和新路街道社区党建服务中心（平型关路471号）</p>

          </div>

          <div className="hr2" style={{marginTop: "20px"}}></div>
          <div className="content">
            <div className="author">
              <img src={require("./icon.png")} alt="" className="aijiaIcon"/>
              <p className="nameTf">爱家君</p>
              <div className="right">
                <a href="tel:18602039256" className="contactBtn">联系ta</a>
              </div>
            </div>
          </div>
          <div className="hr2"></div>


          <div className="content" style={{marginBottom: "30px",paddingBottom:"50px"}}>
            <h3>
              <div className="h3Icon"></div>
              教师简介
            </h3>

            <h4>
              Sara Zhang老师
            </h4>

            <p>跟随Lance Schuler 团队的专业TTC培训，先后获得：</p>
            <li><small>*</small> 200小时INSPYA泛南太平洋瑜伽学院教师认证</li>
            <li><small>*</small> 200小时Yogaalliance美国瑜伽联盟RYT教师认证</li>
            <p>18年接触Barre课程的经历，随后参与Barre 课程培训并成
              为认证老师，目前服务于超级猩猩、舒适堡健身，
              Lynn yoga 、一涧yoga 以及隧道股份集团、自来水管线集
              团、太平洋保险等国企、外资企业内部课程！</p>


            <h3 style={{marginTop: "30px"}}>
              <div className="h3Icon"></div>
              精彩分享
            </h3>


            <img src={require("./h5_yoga_pic1.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ Sara Zhang</p>
            <img src={require("./h5_yoga_pic2.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ Sara Zhang</p>
            <img src={require("./h5_yoga_pic3.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ Sara Zhang</p>
            <img src={require("./h5_yoga_pic4.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ 团课分享</p>
            <img src={require("./h5_yoga_pic5.png")} className="fullHorizontalImg" alt=""/>
            <p style={{textAlign: "center"}}>▲ 团课分享</p>

          </div>


          { this.renderBtn()          }

        </div>
      );

    }
  }

  renderBtn()
  {
    return (<div  className="bottomBigBtn stickFooter disabled">活动结束</div>);

    let {data} = this.state;
    let actId = this.props.match.params.id;
    actId = parseInt(actId);

    if ( data )
    {
      //未报名
      if ( data.join==null )
      {
        let joinTimeEnd = data.activity.join_time_end;
        let now = new Date();
        let time_end = data.activity.time_end;
        if ( time_end )
        {
          //活动时间都结束了
          let timeEndVal = new Date( time_end);
          if ( now.valueOf() > timeEndVal.valueOf() )
          {
            return (<div  className="bottomBigBtn stickFooter disabled">活动结束</div>);
          }
        }
        if ( joinTimeEnd )
        {
          //报名时间结束了
          let joinTimeEndVal = new Date( joinTimeEnd);
          if ( now.valueOf() > joinTimeEndVal.valueOf() )
          {
            return (<div  className="bottomBigBtn stickFooter disabled">报名结束</div>);
          }
        }
        //可报名
        return (<Link to={`./join-${actId}`} className="bottomBigBtn stickFooter">我要报名</Link>);

      }

      // 已报名
      if ( data.join != null )
      {
        //0等待审核，1审核通过，2审核失败	，审核失败则可以继续报名
        let reviewStatus = data.join.review_status;
        if ( reviewStatus == 2 )
        {
          //审核失败则可以继续报名
          return (<Link to={`./join-${actId}`} className="bottomBigBtn stickFooter">我要报名</Link>);

        }else if ( reviewStatus == 1)
        {
          // 可签到
          return (<a onClick={this.onClickCheckIn.bind(this)} className="bottomBigBtn stickFooter">点击签到</a>);

        }else{
          //等审核
          return (<div  className="bottomBigBtn stickFooter disabled">等待审核中</div>);
        }
      }
    }else return null;
  }

  onClickCheckIn(){

    let {data} = this.state;
console.log ( data.join.qrcode);
    TicketPanel.show( data.activity.title,data.join.qrcode);
  }
}